export enum SortField {
    name = 'name',
    // mimeType = 'mimeType',
    // metaDataModifyTime = 'metaDataModifyTime',
    fileModifyTime = 'fileModifyTime',
    size = 'size',
    // linkCreateTime = 'linkCreateTime',
    // linkExpireTime = 'linkExpireTime',
    // numAccesses = 'numAccesses',
    // trashed = 'trashed',
    // sharedOn = 'sharedOn',
    // sharedBy = 'sharedBy',
    // uploadedBy = 'uploadedBy',
}
